import React, { createContext, useCallback, useEffect } from 'react'
import { useContext } from 'react';
import { useState } from 'react';
import { JContext, JStore } from './interfaces';

export const JourneyContextStore = createContext<JContext>(null!)

export default function JourneyContext(props: React.PropsWithChildren<{}>) {
    const [journeyStore, setJourneyStore] = useState<JStore | null>({})

    let contextValues = {
        journeyStore,
        setJourneyStore
    } as JContext

const enterFunction = useCallback((event) => {
    if(event.keyCode === 13) {
        console.log("Enter press captured.");
        // event.preventDefault();
        // event.stopPropagation();
    }
    }, []);

    useEffect(() => {
        document.addEventListener("keydown", enterFunction, false);
        return () => { document.removeEventListener("keydown", enterFunction, false); };
    }, []);

    return <JourneyContextStore.Provider value={contextValues}>{props.children}</JourneyContextStore.Provider>
}

export function useJourneyState() {
    const context = useContext(JourneyContextStore)
    if (!context) {
        throw new Error('useJourneyState must be used within the JourneyContext component!')
    }
    return context
}